import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ScorecardComponent } from './scorecard/scorecard.component';
import { PeriodRangeComponent } from './period-range/period-range.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule
  ],
  declarations: [
    ScorecardComponent,
    PeriodRangeComponent
  ],
  exports: [
    ScorecardComponent,
    PeriodRangeComponent
  ],
})
export class SkuCapsuleUiModule {}
